<template>
    <div>
        <iframe v-if="iframe" src="http://www.aisinogz.com:19876/AisinoFp-test/pd?id=1012018122000011606276413_144000820000_10132076.pdf" frameborder="0" width="500" height=700 style="border: 1px solid red"></iframe>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                iframe: false
            }
        },
        mounted() {
            const pdfUrl = this.$route.query.url
            this.iframe = this.$route.query.iframe
            if(pdfUrl) {
                location.href = pdfUrl
            }
        },
    }
</script>

<style scoped>

</style>